import React from "react";
import Navbar from "./components/Navbar";
import { Routes, Route } from "react-router-dom";
// import Home from "./pages/Home/Home";
import Doctors from "./pages/Doctors";
import Login from "./pages/Login";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Appointment from "./pages/Appointment";
import MyAppointments from "./pages/MyAppointments";
import MyProfile from "./pages/MyProfile";
import Footer from "./components/Footer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Verify from "./pages/Verify";
import Booking from "./pages/Booking/Booking";
import AppointmentDetails from "./pages/Appointment/Appointment";
import BookingLeftPanel from "./components/LeftPanel";
import InvalidPage from "./pages/InvalidPage";
import DoctorLayout from "./pages/DoctorProfile/DoctorProfile";
import { initGA } from "./services/analytics";
import Redirect from "./pages/Redirect/Redirect";

import MarketingHome from "../src/pages/Marketing/Home";
import Terms from "./pages/Marketing/Terms";
import Privacy from "./pages/Marketing/PrivacyPolicy";
import Support from "./pages/Marketing/Support";
import RefundsAndCancellationPolicies from "./pages/Marketing/RefundsCancellations";

initGA();

const App = () => {
    return (
        <div>
            <ToastContainer />
            <div>
                <Routes>
                    <Route path="/terms" element={<Terms />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/refund-policy" element={<RefundsAndCancellationPolicies />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/:alias" element={<DoctorLayout />}>
                        <Route index element={<Booking />} />
                    </Route>
                    <Route path="/:alias/appointment/:id/:token" element={<AppointmentDetails />} />
                    <Route path="/" element={<MarketingHome />} />
                    <Route path="/redirect" element={<Redirect />} />
                    <Route path="*" element={<InvalidPage />} />
                </Routes>
            </div>
        </div>
    );
};

export default App;
